import { Entity, Column, PrimaryGeneratedColumn, ManyToOne, OneToOne, JoinColumn } from "typeorm";
import { GpsCoordinatesEntity } from "./gpscoordinates.entity";
import { StreetEntity } from "./street.entity";

@Entity()
export class AddressEntity {

    @PrimaryGeneratedColumn()
    addressId: number;

    @ManyToOne(() => StreetEntity, street => street.streetId)
    street: StreetEntity;

    @Column()
    houseNum: string;

    @Column()
    zipcode: string;

    @Column({nullable:true})
    apartment: string

    @OneToOne(() => GpsCoordinatesEntity)
    @JoinColumn()
    gpsCoord: GpsCoordinatesEntity
    

}